/**
 * Display labels for the two closed content vocabularies.
 *
 * The API sends both layers as Czech slugs (`regenerace-spanek`, `zaznam-webinare`)
 * because they are identity, not copy: they key the filters, survive a language
 * change, and are what the PDF extractor and the migration fold onto. The label is
 * looked up per language, so the same slug reads "Regenerace & spánek" or
 * "Recovery & sleep".
 *
 * Both resolvers fall back to the slug rather than rendering the missing key. The
 * vocabularies are closed, so a missing translation is a bug — but a raw
 * `regenerace-spanek` chip is a small blemish where `topics.regenerace-spanek` is a
 * visible one.
 */

import type { TFunction } from "i18next";

import type { ContentFormat, ContentTopic } from "~/types/news";

export function topicLabel(t: TFunction, topic: ContentTopic | string): string {
  return t(`topics.${topic}`, { defaultValue: topic });
}

export function formatLabel(
  t: TFunction,
  format: ContentFormat | string,
): string {
  return t(`formats.${format}`, { defaultValue: format });
}
